import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select from 'react-select';
import RoleFilterSection from './RoleFilterSection';

const SeparatorLine = styled.div`
background-image: url("./images/website/line.png");
background-repeat: repeat-x;
height: 1px;
width: 100%;
`;

function RoleFilter({
  handleFilterChange,
  handleRoleChange,
  handleVersionChange,
  versionSet,
  selectedVersions,
  selectedFilter
}) {

  var selectedVersionsAsArray = selectedVersions.split(',');

  return <div className="role-filter">
    <div className="role-filter__filter">
      <SeparatorLine />
      <div className="role-filter__role-select">
        <RoleFilterSection isInitiallyExpanded={true} headingText="Sort by character">
          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleNone" value="" defaultChecked={selectedFilter.length < 1} onChange={handleRoleChange} />
            <label htmlFor="filterRoleNone">None</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleTownsfolk" value="townsfolk" defaultChecked={selectedFilter == 'townsfolk'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleTownsfolk">Townsfolk</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleOutsider" value="outsider" defaultChecked={selectedFilter == 'outsider'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleOutsider">Outsider</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleMinion" value="minion" defaultChecked={selectedFilter == 'minion'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleMinion">Minion</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleDemon" value="demon" defaultChecked={selectedFilter == 'demon'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleDemon">Demon</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleTravellers" value="travellers" defaultChecked={selectedFilter == 'travellers'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleTravellers">Travellers</label>
          </div>

          <div className="radio" style={{marginTop: 0}}>
            <input type="radio" name="radioRoleOptions" className="filterRole" id="filterRoleFabled" value="fabled" defaultChecked={selectedFilter == 'fabled'} onChange={handleRoleChange} />
            <label htmlFor="filterRoleFabled">Fabled</label>
          </div>
        </RoleFilterSection>
      </div>
      <SeparatorLine />
      <div className="role-filter__version-select">
        <RoleFilterSection isInitiallyExpanded={false} headingText="Filter by edition">
          {
            versionSet.map((item, i) => {
              let label = item.label;
              let labelStartIndex = label.indexOf('-');

              if (labelStartIndex > 0) label = label.substring(labelStartIndex + 1).trim();

              return (
                <div key={i} className="checkbox">
                  <input
                    type="checkbox"
                    name="versionOptions"
                    className="filterRole"
                    id={item.id}
                    value={item.value}
                    onChange={handleVersionChange}
                    checked={selectedVersionsAsArray.indexOf(item.value) > -1}
                  />
                  <label htmlFor={item.id}>{label}</label>
                </div>
              )
            })
          }
        </RoleFilterSection>
      </div>
      <SeparatorLine />
      <div className="role-filter__input">
        <input id="filterText" className="form-control" type="text" onChange={handleFilterChange} placeholder="Search by name" />
      </div>
    </div>
  </div>
}

RoleFilter.propTypes = {
  resetFilter: PropTypes.func,
  handleFilterChange: PropTypes.func,
  handleRoleChange: PropTypes.func,
  handleVersionChange: PropTypes.func,
  versionSet: PropTypes.array,
  selectedVersions: PropTypes.string,
  selectedFilter: PropTypes.string,
};

export default RoleFilter;
